<!-- <p>host-visitor-status works!</p> -->

<div
  [ngClass]="{
    'manage-visitor-container-dialog': isDialog,
    'manage-visitor-container': !isDialog
  }"
>
  <div
    class="manage-visitor-header"
    [ngStyle]="!isDialog ? { top: '0', position: 'fixed' } : {}"
  >
    Visitor Logbook
    <button *ngIf="isDialog" mat-mini-fab [mat-dialog-close]="true">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div
    *ngIf="isFetched"
    [ngClass]="{
      'manage-visitor-details':
        (screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet) && !isDialog,
      'manage-visitor-details-mobile': screenSize == ScreenType.Mobile && !isDialog,      
      'manage-visitor-details-dialog': isDialog && screenSize != ScreenType.Mobile,
      'manage-visitor-details-dialog-mobile': screenSize == ScreenType.Mobile&&isDialog,
    }"
  >
    <div class="visitor-pre-verified-table">
      <table
        mat-table
        [dataSource]="visitors"
        *ngIf="screenSize != ScreenType.Mobile"
      >
        <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef>No.</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ i + 1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="visname">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
          >
            Visitor Name
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.firstName + " " + row.lastName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="hostname">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
          >
            Host Name
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.hostName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
          >
            DateTime
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ getFormatedDate(row.visitDateTime) | date : "MMM d @ hh:mm a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Details">
          <th
            style="text-align: center"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          >
            Details
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            <button mat-flat-button (click)="toggleDetails(element)">
              <mat-icon
                *ngIf="currentVisitorId != element.visitorID || !isOpen"
                >{{ "expand_more" }}</mat-icon
              >
              <mat-icon
                *ngIf="isOpen && currentVisitorId == element.visitorID"
                >{{ "expand_less" }}</mat-icon
              >
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="purpose">
          <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
            Purpose
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.purpose?.length == 0 ? "Not Mentioned" : row.purpose }}
          </td>
        </ng-container>
        <ng-container matColumnDef="security">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
          >
            Visitor Status
          </th>
          <td
            style="
              display: flex;
              justify-content: space-evenly;
              align-items: center;
              padding: 0 10px;
              height: 52px;
            "
            mat-cell
            *matCellDef="let row"
          >
            <button
              [ngStyle]="
                (row.checkIn != null &&
                  row.inProgressStatusTime &&
                  row.completeStatusTime == null) ||
                (row.checkIn != null &&
                  row.inProgressStatusTime == null &&
                  row.completeStatusTime == null)
                  ? { 'background-color': 'green' }
                  : row.checkIn &&
                    row.inProgressStatusTime &&
                    row.completeStatusTime
                  ? { 'background-color': 'gray' }
                  : { 'background-color': 'red' }
              "
              class="security-button"
              mat-flat-button
            >
              {{
                row.checkIn != null && row.inProgressStatusTime == null
                  ? "Checked In"
                  : row.checkIn &&
                    row.inProgressStatusTime &&
                    row.completeStatusTime == null
                  ? "In-Progress"
                  : row.checkIn &&
                    row.inProgressStatusTime &&
                    row.completeStatusTime
                  ? "Completed"
                  : "Pending"
              }}
            </button>
            <button
              *ngIf="row.checkIn && row.inProgressStatusTime"
              [ngStyle]="
                row.completeStatusTime == null
                  ? { 'background-color': '#ffbf00' }
                  : { 'background-color': 'gray' }
              "
              style="color: white; font-size: 18px; padding: 0 5px"
              mat-flat-button
            >
              {{ row.timerValue }}
            </button>
          </td>
        </ng-container>
        <tr
          class="table-header"
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div
        class="mobile-table-card-wrapper"
        *ngIf="screenSize == ScreenType.Mobile"
      >
        <div
          *ngFor="let visitor of visitors"
          class="mobile-table-card-container"
        >
          <div class="card-content">
            <div>
              Name : <b>{{ visitor.firstName + " " + visitor.lastName }}</b>
            </div>
            <div>
              Date : <b>{{ visitor.visitDateTime | date : "dd/MM/yy" }}</b>
            </div>
            <div>
              Host :
              <b
                [ngStyle]="
                  visitor.securityStatus == 4
                    ? { color: 'green', 'font-size': '16px' }
                    : visitor.securityStatus == 5
                    ? { color: 'red', 'font-size': '16px' }
                    : {}
                "
                >{{ visitor.hostName }}
              </b>
            </div>
            <div>
              Purpose :
              <b>{{ visitor.purpose ? visitor.purpose : "Not Mentioned" }}</b>
            </div>
          </div>
          <div class="card-action-logbook">
            <div class="card-action">
              <button
                [ngStyle]="
                  (visitor.checkIn != null &&
                    visitor.inProgressStatusTime &&
                    visitor.completeStatusTime == null) ||
                  (visitor.checkIn != null &&
                    visitor.inProgressStatusTime == null &&
                    visitor.completeStatusTime == null)
                    ? { 'background-color': 'green' }
                    : visitor.checkIn &&
                      visitor.inProgressStatusTime &&
                      visitor.completeStatusTime
                    ? { 'background-color': 'gray' }
                    : { 'background-color': 'red' }
                "
                class="security-button"
                mat-flat-button
              >
                {{
                  visitor.checkIn != null &&
                  visitor.inProgressStatusTime == null
                    ? "Checked In"
                    : visitor.checkIn &&
                      visitor.inProgressStatusTime &&
                      visitor.completeStatusTime == null
                    ? "In-Progress"
                    : visitor.checkIn &&
                      visitor.inProgressStatusTime &&
                      visitor.completeStatusTime
                    ? "Completed"
                    : "Pending"
                }}
              </button>
              <button
                *ngIf="visitor.checkIn && visitor.inProgressStatusTime"
                [ngStyle]="
                  visitor.completeStatusTime == null
                    ? { 'background-color': '#ffbf00' }
                    : { 'background-color': 'gray' }
                "
                style="color: white; font-size: 18px; padding: 0 5px"
                mat-flat-button
              >
                {{ visitor.timerValue }}
              </button>
            </div>
            <div class="card-details">
              <button mat-mini-fab (click)="toggleDetails(visitor)">
                <mat-icon
                  *ngIf="currentVisitorId != visitor.visitorID || !isOpen"
                  >{{ "expand_more" }}</mat-icon
                >
                <mat-icon
                  *ngIf="isOpen && currentVisitorId == visitor.visitorID"
                  >{{ "expand_less" }}</mat-icon
                >
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="visitors.length == 0" class="preview-content-empty">
        No visitor
      </div>
    </div>
    <div class="visitor-gate-entry-form" *ngIf="isOpen">
      <!-- <div *ngIf="isApprovePopUp" style="margin-top: 45px"></div> -->
      <form [formGroup]="visitorPreVerifiedForm">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 4"
          rowHeight="75px"
          gutterSize="10px"
        >
          <mat-grid-tile [rowspan]="screenSize == ScreenType.Mobile ? 3 : 4">
            <img [src]="visitorPreVerifiedForm.controls.profilePicture.value"
          /></mat-grid-tile>
          <mat-grid-tile [rowspan]="screenSize == ScreenType.Mobile ? 3 : 4">
            <img [src]="visitorPreVerifiedForm.controls.identityID.value"
          /></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>First Name</mat-label>
              <input
                readonly
                matInput
                formControlName="firstName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Last Name</mat-label>
              <input
                readonly
                matInput
                formControlName="lastName"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Email</mat-label>
              <input
                readonly
                matInput
                formControlName="email"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Contact Number</mat-label>
              <input
                readonly
                matInput
                formControlName="phoneNumber"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Address</mat-label>

              <textarea
                readonly
                formControlName="visitorAddress"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="1"
                matInput
              ></textarea>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Purpose</mat-label>
              <input
                readonly
                matInput
                formControlName="purpose"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Pass validity</mat-label>
              <input
                readonly
                matInput
                formControlName="passValidity"
              /> </mat-form-field
          ></mat-grid-tile>

          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Car Registration</mat-label>
              <input
                readonly
                matInput
                formControlName="carRegistration"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Check In</mat-label>
              <input
                readonly
                matInput
                formControlName="checkIn"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Check Out</mat-label>
              <input
                readonly
                matInput
                formControlName="checkOut"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="visitorPreVerifiedForm.controls.securityStatus.value == '5'"
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
            ><mat-form-field
              hideRequiredMarker
              subscriptSizing="dynamic"
              appearance="outline"
            >
              <mat-label>Meet Comments</mat-label>
              <textarea
                readonly
                formControlName="meetingComments"
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="1"
              ></textarea></mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              !(
                visitorPreVerifiedForm.controls.securityStatus.value != '1' ||
                visitorPreVerifiedForm.controls.checkIn.value == null
              )
            "
            ><div class="notify-host-button">
              <button (click)="onClickStatusInprogress(4)" mat-raised-button>
                In Progress
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="visitorPreVerifiedForm.controls.securityStatus.value === '4'"
            ><div class="notify-host-button">
              <button
                (click)="onCompleteOpenDialog()"
                [disabled]="isFetchingRequest"
                mat-raised-button
              >
                Complete
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
  </div>
  <div *ngIf="!isFetched">
    <div class="visitor-msg">
      <h4>Fetching Details!</h4>
      <br />
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
<ng-template #VisitorMeetingComments>
  <div class="meeting-comment-wrapper">
    <div class="aumye-header">Meeting Comments</div>
    <mat-dialog-content>
      <form [formGroup]="meetingCommentForm">
        <div class="comment-box-wrapper">
          <mat-form-field>
            <mat-label> <i>Write your comments!</i></mat-label>
            <textarea
              formControlName="meetingComment"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="7"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="visitor-msg" style="flex-direction: column">
          <b
            ><i>
              {{
                "“Would you like to share the minutes of the meeting with the visitor as well?"
              }}</i
            ></b
          >
          <div
            class="button-group"
            style="width: 100%; display: flex; justify-content: flex-end"
          >
            <mat-button-toggle-group formControlName="sendVisitor">
              <mat-button-toggle value="yes">Yes</mat-button-toggle>
              <mat-button-toggle value="no">No</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions style="display: flex; justify-content: center">
      <button
        [disabled]="meetingCommentForm.invalid"
        [mat-dialog-close]="true"
        mat-raised-button
      >
        Save
      </button>
      <button [mat-dialog-close]="false" mat-raised-button>Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>
<ng-template #InProgresslDialog>
  <h2 matDialogTitle>Applying Changes!</h2>
  <mat-dialog-content>
    <div class="visitor-msg">
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #FailedErrorDialog>
  <h2 matDialogTitle>Response Failed</h2>
  <mat-dialog-content>
    <b
      ><i> {{ "Error occured, Please retry!" }}</i></b
    >
    <br />
    <div class="visitor-msg">
      <button mat-raised-button (click)="refreshWindow()">Re-try</button>
      <button
        style="margin-left: 20px"
        *ngIf="isDialog"
        mat-raised-button
        (click)="closeDialog()"
      >
        Close
      </button>
    </div>
  </mat-dialog-content>
</ng-template>
